/**
 * Key object
 */
Game.Prefabs.Door = function( game, x, y, type, group, properties ) {

	console.log( 'type of door =', type );

	if ( ! type || type === 'door' ) {
		type = 'door-vertical';
	}

	if ( ! properties.properties ) {
		properties.properties = {};
	}

	if ( ! properties.properties.color ) {
		properties.properties.color = 'blue';
	}

	if ( ! properties.properties.callback ) {
		properties.properties.callback = '';
	}


	var slug = type + '-' + properties.properties.color;

	// Setup Key.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y + Game.Utils.Map.TILE_HALF_SIZE, slug );

	// Add key animations.
	this.animations.add( 'shut', [ 0 ], 5, false );
	this.animations.add( 'open', [ 0, 1, 2, 3, 4 ], 24, false );
	this.animations.add( 'close', [ 4, 3, 2, 1, 0 ], 24, false );

	console.log( 'new door', slug );

	// Set the anchor to the middle to center the key on the tile.
	this.anchor.setTo( 0.5, 0.5 );

	// Play the spin animation by default.
	this.animations.play( 'shut' );

	var tileX = x / Game.Utils.Map.TILE_SIZE;
	var tileY = y / Game.Utils.Map.TILE_SIZE;

	this.name = properties.name;

	this.doorTiles = [];
	this.doorTiles.push( [ tileX, tileY - 1 ] );
	this.doorTiles.push( [ tileX, tileY ] );
	this.doorTiles.push( [ tileX, tileY + 1 ] );

	Game.Utils.Map.add_tile_collision( this.doorTiles, Game.Utils.Map.TILE_COLLISION, [ 1, 1, 1, 1 ] );

	Game.Utils.Map.add_zone(
		{
			door: this,
			type: 'door',
			x: x - ( Game.Utils.Map.TILE_SIZE * 2 ),
			y: y - ( Game.Utils.Map.TILE_SIZE * 2 ),
			width: Game.Utils.Map.TILE_SIZE * 5,
			height: Game.Utils.Map.TILE_SIZE * 5,
			name: properties.name,
			callback: properties.properties.callback,
		}
	);

	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Door.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Door.constructor = Game.Prefabs.Door;


Game.Prefabs.Door.prototype.open = function() {

	if ( 'open' === this.state ) {
		return;
	}

	this.animations.play( 'open', false );

	this.state = 'open';

};

